import { useCallback } from "react";

export const useTimeUtil = () => {
  const formatDate = useCallback((millis: string | number, format: string) => {
    if (!millis) return "";
    const date = new Date(millis);
    if (isNaN(date.getTime())) return "";

    const pad = (num: number) => num.toString().padStart(2, "0");
    const months = [
      "Jan",
      "Feb",
      "Mar",
      "Apr",
      "May",
      "Jun",
      "Jul",
      "Aug",
      "Sep",
      "Oct",
      "Nov",
      "Dec",
    ];
    const fullMonths = [
      "January",
      "February",
      "March",
      "April",
      "May",
      "June",
      "July",
      "August",
      "September",
      "October",
      "November",
      "December",
    ];

    const year = date.getFullYear();
    const monthIndex = date.getMonth();
    const day = date.getDate();
    const hours = date.getHours();
    const minutes = date.getMinutes();
    const seconds = date.getSeconds();

    const replacements: Record<string, string> = {
      YYYY: year.toString(),
      YY: year.toString().slice(-2),
      MMMM: fullMonths[monthIndex],
      MMM: months[monthIndex],
      MM: pad(monthIndex + 1),
      DD: pad(day),
      HH: pad(hours),
      mm: pad(minutes),
      ss: pad(seconds),
    };

    return format.replace(
      /YYYY|YY|MMMM|MMM|MM|DD|HH|mm|ss/g,
      (match) => replacements[match]
    );
  }, []);

  const formatIso = useCallback(
    (isoString: string, format: string = "DD/MM/YYYY HH:mm") => {
      return formatDate(isoString, format);
    },
    [formatDate]
  );

  return { formatDate, formatIso };
};
